import { NavigationItem } from "@repo/apis/browse-navigation-v2";

function extractUrl(url: string | null): string {
  if (!url) return "";
  // Strip out domain and locale (e.g., "https://www.topshop.com/gb") only keep the relative path for internal navigation
  return url.replace(
    /^https:\/\/[a-zA-Z]{1,}\.[a-zA-Z]{1,}\.com\/[a-zA-Z]{1,}/,
    "",
  );
}

export type TransformedNavigationItem = NavigationItem & {
  title: string;
  url: string;
};

export type GroupedNavigationItems = {
  groupTitle: string;
  items: TransformedNavigationItem[];
};

export function extractNavigationItems(
  navigation: NavigationItem[] | undefined,
  floor: "topshop" | "topman",
): GroupedNavigationItems[] {
  const result: GroupedNavigationItems[] = [];

  if (!Array.isArray(navigation)) {
    return result;
  }

  const floorNav = navigation.find(
    (nav) => nav.content.title.toLowerCase() === floor,
  );

  if (!floorNav?.children) {
    return result;
  }

  for (const container of floorNav.children) {
    if (container.type === "container" && Array.isArray(container.children)) {
      const groupItems: TransformedNavigationItem[] = [];

      for (const categoryItem of container.children) {
        if (categoryItem.type === "link" && categoryItem.link?.webUrl) {
          const transformedItem: TransformedNavigationItem = {
            ...categoryItem,
            id: categoryItem.link?.categoryId
              ? String(categoryItem.link?.categoryId)
              : categoryItem.content.title,
            title: categoryItem.content.title,
            url: extractUrl(categoryItem.link.webUrl),
            children: categoryItem.children,
          };
          groupItems.push(transformedItem);
        }
      }

      if (groupItems.length > 0) {
        result.push({
          groupTitle: container.content.title,
          items: groupItems,
        });
      }
    }
  }
  return result;
}
